import script from "./EditSupervisor.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSupervisor.vue?vue&type=script&setup=true&lang=js"

import "./EditSupervisor.vue?vue&type=style&index=0&id=3e6b5882&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e6b5882"]])

export default __exports__